exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\n.xs-group-validatorRed {\n  border: 1px solid #ff0000;\n  border-radius: 5px;\n}\n.xs-group-validatorNone {\n  border: 0;\n}\n", ""]);

// exports
